module.exports = __webpack_public_path__ + "static/media/32.c82f02b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/32.png
// module id = 536
// module chunks = 0